<template>
  <!--
    name: 租先知
   -->
  <div class="zuxianzhi d-c-c">
    <div v-if="!show" style="margin-top: 40px; width: 800px;">
      <div style="text-indent: 2em;">
        <p>提示：请生成报告后再查看该报告！</p>
        <p>新颜报告没有生成</p>
      </div>
      <div class="d-s-c d-r" style="margin: 0;">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="(item, index) in typeOptions"
            :label="item.label"
            :value="item.value"
            :key="index"
          ></el-option>
        </el-select>
        <el-button
          type="warning"
          style="margin-left: 20px;"
          plain
          size="large"
          @click="createReport"
          >点击查看租先知报告</el-button
        >
      </div>
    </div>
    <div v-else class="zxz_info_box">
      <el-button
        icon="el-icon-refresh"
        type="warning"
        plain
        @click="reCreateVisible = true"
        class="info_refresh_btn"
      ></el-button>

      <div>请求编号：{{ request_id }}</div>
      <!-- 报告 -->
      <h1>报告</h1>
      <!-- 个人信息 -->
      <div class="zxz_b_content d-s-c d-r">
        <h2>个人信息</h2>
        <table v-if="basic_info.length !== 0">
          <tr
            v-for="(item, index) in basic_info"
            :key="index"
            style="width: 100%;"
          >
            <td
              v-for="(value, key) in item"
              :class="key % 2 === 0 ? 'bold' : ''"
              :key="key"
              style="width: 12.5%;"
            >
              {{ value }}
            </td>
          </tr>
        </table>
      </div>

      <!-- 雷达 -->
      <template v-if="info.report.radar">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="radar_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>雷达</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in radar_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'bold' : ''"
                :key="key"
                style="width: 12.5%;"
              >
                {{ value }}
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 当前逾期 -->
      <template v-if="info.report.tanza">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="overdue_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>当前逾期</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in overdue_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'bold' : ''"
                :key="key"
                style="width: 12.5%;"
              >
                {{ value }}
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 黑名单 -->
      <template v-if="info.report.zblacklist">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="blacklist_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>黑名单</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in blacklist_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'bold' : ''"
                :key="key"
                style=""
              >
                <div v-for="(v, i) in value" class="d-b-c d-r">
                  <span class="gray" style="font-weight: bold;">{{
                    staticMap[i]
                  }}</span
                  ><span>{{ v }}</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 多头监控 -->
      <template v-if="info.report.zlengding">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="zld_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>多头监控</h2>
              </td>
            </tr>
            <template v-for="(item, index) in zld_info">
              <tr v-if="index % 2 === 0" style="width: 100%;">
                <td colspan="8">
                  <h3>{{ item }}</h3>
                </td>
              </tr>
              <tr v-else v-for="(list, i) in item">
                <td
                  v-for="(value, key) in list"
                  :class="i === 0 || key === 0 ? 'bold' : ''"
                  :key="key"
                  style="width: 10%;"
                >
                  <!-- <div v-if ></div> -->
                  <span class="word-wrap">{{ value }}</span>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </template>

      <!-- 借贷履约记录 -->
      <template v-if="info.report.snxyp">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="loan_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>借贷履约记录</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in loan_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'long_td' : 'short_td'"
                :key="key"
              >
                {{ value }}
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 高危风险核查 -->
      <template v-if="info.report.highrisk">
        <div class="zxz_b_content d-s-c d-r">
          <table style="width: 100%">
            <tr>
              <td>
                <h2>高危风险核查</h2>
              </td>
              <td style="width: 80%; text-align: center; font-size: 20px;">
                <span class="blue">{{ info.report.highrisk }}</span>
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 风险标签 info.report.riskable -->
      <template v-if="info.report.riskable">
        <div class="zxz_b_content d-s-c d-r">
          <table style="width: 100%">
            <tr>
              <td>
                <h2>风险标签</h2>
              </td>
              <td style="width: 80%; text-align: center; font-size: 20px;">
                <span class="blue">{{ info.report.riskable }}</span>
              </td>
            </tr>
          </table>
        </div>
      </template>
    </div>

    <el-dialog
      title="重新生成报告"
      :visible.sync="reCreateVisible"
      width="600px"
    >
      <div class="d-s-c d-r" style="margin: 0; height: 100px;">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="(item, index) in typeOptions"
            :label="item.label"
            :value="item.value"
            :key="index"
          ></el-option>
        </el-select>
        <el-button
          type="warning"
          style="margin-left: 20px;"
          plain
          size="large"
          @click="createReport"
          >点击查看租先知报告</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import useApi from "@/api/useApi";
import Mapper from "./common/staticMap";
import staticMap from "./common/staticMap";
import { isEmpty } from "@/utils/tools";
export default {
  props: ["report", "order_id", "userInfo"],
  data() {
    return {
      show: false,
      reCreateVisible: false,
      form: {
        telephone: "15751099679",
        name: "曹敬宝",
        idcardno: "321322199712017216",
        type: "Hv2",
        key: "zuxz"
      },
      request_id: "",
      typeOptions: [
        { label: "基础版", value: "L" },
        { label: "标准版", value: "M" },
        { label: "高级版", value: "H" },
        { label: "高级版V2", value: "Hv2" },
        { label: "高级版V3", value: "Hv3" },
      ],
      omit: ["Banks", "Non-bankFin", "Others"],
      info: {
        report: {},
        basic: {}
      },
      basic_info: [],
      radar_info: [],
      overdue_info: [],
      blacklist_info: [],
      zld_info: [], // 多头
      loan_info: [], // 借款
      staticMap: {}
    };
  },
  methods: {
    // 生成报告
    async createReport() {
      const params = { ...this.form, order_id: this.order_id };
      const { data, msg } = await useApi().getReportByKey(params);
      if (Object.keys(data).length === 0) return;
      this.info = JSON.parse(data).data;
      this.formatData();
      this.show = true;
    },
    // 映射处理 -> 对象转换成 八个一行的二位数组
    mapData(target /** string */, origin /** obj */) {
      if (!origin || origin === null || origin === undefined) return;
      if (typeof origin === "object" && Object.keys(origin).length === 0)
        return;
      let arr = [];
      Object.entries(origin).map(([key, value], index) => {
        if (index % 4 === 0 && index !== 0) {
          this[target].push(arr);
          arr = [];
        }
        arr.push(Mapper[key] ? Mapper[key] : key);
        arr.push(value);
      });
      if (arr.length > 0) this[target].push(arr);

      // console.log(this[target]);
    },
    // 单独处理多头监控
    mapMultiZLD() {
      if (this.info.report.zlengding) {
        const titleMap = ["D7", "D30", "D90", "D180", "D360", "D540", "D720"];
        const titles = [
          "",
          "7天",
          "30天",
          "90天",
          "180天",
          "360天",
          "540天",
          "720天"
        ];
        const values = [
          "averageLoanGapDays",
          "averageTenantGapDays",
          "loanTypes",
          "tenantTypes",
          "totalAppsCount",
          "totalcrossTenantAppsCount",
          "totalmobileCount",
          "Banks",
          "Non-bankFin",
          "Others"
        ];
        const data = this.zld_info.flat();
        data.map((item, index) => {
          // item -> D...
          if (index % 2 !== 0) {
            let temp = [];
            temp.push(titles);
            values.map(i => {
              // i -> averageLoanGapDays, averageTenantGapDays, ...
              let arr = [];
              arr.push(this.staticMap[i]);
              titleMap.map(key => arr.push(item[key][i])); // key -> D...
              if (typeof arr[2] === "object")
                arr = arr.map(value => {
                  if (typeof value === "string") return value;
                  return Object.entries(value)
                    .map(([key, value]) => `${Mapper[key]}：${value}\n`)
                    .join();
                });
              temp.push(arr);
            });
            data[index] = temp;
          }
        });
        this.zld_info = data;
        // console.log(this.zld_info);
      }
    },
    formatData() {
      const target = this.info.report;
      const handleMap = {
        basic_info: this.info.basic,
        radar_info: target.radar,
        overdue_info: target.tanza,
        blacklist_info: target.zblacklist,
        zld_info: target.zlengding,
        loan_info: "",
        plinfp: target.plinfp
      };
      if (target.snxyp) handleMap.loan_info = target.snxyp.data;
      Object.entries(handleMap).map(([i, v]) => this.mapData(i, v));
      this.mapMultiZLD();
    }
  },
  created() {
    this.staticMap = Mapper;

    this.form.telephone = this.userInfo.mobile;
    this.form.name = this.userInfo.username;
    this.form.idcardno = this.userInfo.usernum;

    this.show =
      this.report === "[]" ||
      this.report === "" ||
      this.report === undefined ||
      this.report === null
        ? false
        : true;
    if (!this.show) return;
    const detail = JSON.parse(this.report)
      .filter(i => i.zu_describe === "zxz")
      .pop();
    if (detail) {
      const res = JSON.parse(detail.zu_values);
      console.log(res);
      this.request_id = res.request_id;
      this.info = res.data;
    } else this.show = false;
    this.formatData();
  }
};
</script>

<style lang="scss" scoped>
@import "./common/report.scss";
</style>



// WEBPACK FOOTER //
// src/views/fengkong/operation/zuXianZhi.vue